import { OnInit } from '@angular/core';
var SearchResultHeaderComponent = /** @class */ (function () {
    function SearchResultHeaderComponent() {
    }
    SearchResultHeaderComponent.prototype.ngOnInit = function () {
    };
    return SearchResultHeaderComponent;
}());
export { SearchResultHeaderComponent };
